import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-pesquisa',
  templateUrl: './pesquisa.component.html',
  styleUrls: ['./pesquisa.component.scss'],
})
export class PesquisaComponent implements OnInit {
  resultadosBusca: any;
  deslocamento = 0;
  paginaAtual: number;
  totalPaginas: number;
  stringBusca = '';
  totalResultados: any;
  realizouBusca: boolean;
  componenteRef = 'pesquisa';
  labelInput = 'Termo de busca';
  mensagem: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router) {

  }

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      const searchData = data.resultadoBusca;
      this.resultadosBusca = searchData.itens;
      this.paginaAtual = searchData.paginaAtual;
      this.totalPaginas = searchData.totalPaginas;
      this.totalResultados = this.resultadosBusca.length > 0 ? searchData.totalItens : null;
    });

    if (!this.totalResultados || (!this.totalResultados && this.realizouBusca)) {
      this.mensagem = 'Desculpe, não encontramos nenhum resultado compatível com sua busca.';
    }

    if (this.totalResultados) {
      this.mensagem = 'Total de resultados encontrados ' + this.totalResultados;
    }
  }

  receiveInput(input: any) {
    this.realizouBusca = true;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/pesquisa'], {
        queryParamsHandling: 'merge',
        queryParams: {
          pagina: 1,
          query: input.stringBusca,
        },
      });
    });
  }

  onPaginaSelecionada(numeroPagina: number) {
    this.paginaAtual = numeroPagina;
    this.router.navigate(['/pesquisa'], {
      queryParamsHandling: 'merge',
      queryParams: {
        pagina: numeroPagina,
      },
    });
  }
}
